import { register } from '|>/shared/vjs'
import { BaseMenuItem } from '../base'
import { LocalEvents } from './local-events'

/**
 * Interface for any component that can trigger events
 */
interface IEventContainer {
  trigger(event: string, data?: any): void
}

/**
 * Settings menu back button
 *
 * @property {string} title - заголовок кнопки "Назад"
 * @property {string} backEvent - событие для возврата на предыдущее меню
 */
@register
export class SettingsBackTitle extends BaseMenuItem {
  declare options_: any
  declare container: IEventContainer | undefined

  override createEl() {
    return super.createEl('li', {
      className: 'vjs-menu-title',
      textContent: this.localize(this.options_.title),
      tabIndex: -1,
    })
  }

  override handleClick() {
    const backEvent = this.options_.backEvent
    this.container?.trigger(backEvent)
  }
}

SettingsBackTitle.options = {
  title: 'Back',
  backEvent: LocalEvents.SettingsActivateMainMenu,
}
